import { useState } from 'react';
import { getBackendUrl } from '@/lib/api-config';

export const useGetBackendUrl = () => {
  const [backendUrl] = useState<string>(getBackendUrl);
  return backendUrl;
};
